module.exports = __webpack_public_path__ + "img/meu-yalo.92d7baff.jpg";